const Module3Config = {
  day1: {
    learn: {
      video: '1f79d364acec50c99b1ea66939f0/480.m3u8',
      song: 'appfiles/expressions/school_photo_montage_music_1.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: '8495f8da70467b19ee5e488a70f4/480.m3u8',
    },
    rewardOption1: 'CactusTall',
    rewardOption2: 'CactusTall2',
  },
  day2: {
    learn: {
      video: 'd78052408766d9458ad7e6f92fe3/480.m3u8',
      song: 'appfiles/expressions/school_photo_montage_music_2.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: 'b250de7eda00ae4c047780d1e5ea/480.m3u8',
    },
    rewardOption1: 'Tent',
    rewardOption2: 'TentOld',
  },
  day3: {
    learn: {
      video: 'ba87114165311adef155b69893fa/480.m3u8',
      song: 'appfiles/expressions/school_photo_montage_music_3.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: 'aea2a3883304e515a664ce21547d/480.m3u8',
    },
    rewardOption1: 'Hawk',
    rewardOption2: 'Owl',
  },
  day4: {
    introVideo: '2e451b2654c34345f34b2fd722f4/480.m3u8',
    rewardOption1: 'BootsHiking',
    rewardOption2: 'BootsCowboy',
    photoTime: {
      // video1: '0f3ed57ed3560b50aec6407c510c/480.m3u8',
      video1: 'Module3Videos/phototime.mp4',
      video2: '9ebb57c21f5ea6a1e820d5ae47d1/480.m3u8',
    },
    singingTime: {
      intro: '570909b0677de276ed8f0e9e25ae/480.m3u8',
      demoMusic: '',
      singAlongMusic: 'appfiles/expressions/school_expressions_singalong.m4a',
      instrumentalMusic:
        'appfiles/expressions/school_expressions_instrumental.m4a',
      singingAlongVideo:
        'appfiles/expressions/singingtime_expressions_demo.mp4',
      instrumentalVideo:
        'appfiles/expressions/singingtime_expressions_karaoke.mp4',
    },
  },
  day5: {
    introVideo: '60f5f905e57d201d70c0fad5e160/480.m3u8',
    rewardOption1: 'Lantern',
    rewardOption2: 'Fire',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: '3aa48e232e6c26f117ed6dc17ae6/480.m3u8',
      afterVideo: '7feb18b57382a09cd59e90948f41/480.m3u8',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption1: 'CactusPrickly',
    rewardOption2: 'CactusBarell',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: '18d9e51fe3a3385d63c9d3fab927/480.m3u8',
      afterVideo: '6c9ac7d4b7a0162b4748eebde8fe/480.m3u8',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption1: 'Canteen',
    rewardOption2: 'Backpack',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: '4c3988cb9d33a4c8d4bd09a459cb/480.m3u8',
      afterVideo: '3509bd2c255e0481b631b074c8cf/480.m3u8',
      animal: true,
      text: 'Record yourself singing, \n "I am a very important person!"',
      name: 'expressions_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption1: 'MoonCresent',
    rewardOption2: 'MoonFull',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: '54c9795dcad5f3e618b94659ba6c/480.m3u8',
      afterVideo: 'b778774b9c4348c158059c87177c/480.m3u8',
      animal: true,
      text: 'Record yourself making a silly face and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: '6bd31a42d2a58d0960620e45721f/480.m3u8',
    rewardOption1: 'Bandanna',
    rewardOption2: 'Hat',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: 'fb06ffb738dbcfd136baa67a4ecf/480.m3u8',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_9.mp4',
    },
    surprise: {
      video: 'eda85b30f583de7fa6792097d432/480.m3u8',
      song: 'appfiles/expressions/faces_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/ask_affirmation.mp4',
        'userfiles/{student-id}/expressions_celebration_surprise_6.mp4',
        'userfiles/{student-id}/expressions_smile.jpg',
        'influencers/{influencer-id}/expressions_video_message.mp4',
        'userfiles/{student-id}/expressions_celebration_surprise_8.mp4',
        'userfiles/{student-id}/expressions_silly_photo_3.jpg',
        'userfiles/{student-id}/expressions_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module3Config;
